import React from 'react';
import { useScrollSpy } from '../hooks/useScrollSpy';
import { ScrollArea } from './ui/scroll-area';
import { cn } from '../lib/utils';

const sections = [
  { id: 'overview', label: 'Overview' },
  { id: 'teams-gameplay', label: 'Teams & Gameplay' },
  { id: 'song-selection', label: 'Song Selection' },
  { id: 'remakes-covers', label: 'Remakes & Covers' },
  { id: 'guessing-rules', label: 'Guessing Rules' },
  { id: 'scoring', label: 'Scoring' },
  { id: 'challenges', label: 'Challenges' },
  { id: 'tie-breaking', label: 'Tie-Breaking' },
  { id: 'imperfections', label: 'Color of the Game' },
  { id: 'playlist-accuracy', label: 'Playlist Accuracy' },
  { id: 'edm-problem', label: 'EDM Problem' },
];

const RulesSidebarNav = ({ onItemClick }) => {
  const activeSection = useScrollSpy(sections.map(s => s.id));

  const handleClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      onItemClick?.();
    }
  };

  return (
    <ScrollArea className="h-full">
      <nav className="space-y-1" data-testid="rules-sidebar-nav">
        {sections.map((section) => {
          const isActive = activeSection === section.id;
          return (
            <button
              key={section.id}
              onClick={() => handleClick(section.id)}
              data-testid={`rules-sidebar-nav-item-${section.id}`}
              className={cn(
                'sidebar-item group relative flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm transition-colors hover:bg-[hsl(var(--muted))]',
                isActive
                  ? 'active bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] hover:bg-[hsl(var(--accent))]'
                  : ''
              )}
              aria-current={isActive ? 'true' : undefined}
            >
              <span className="tape-stripe" />
              <span className="flex-1 text-left">{section.label}</span>
            </button>
          );
        })}
      </nav>
    </ScrollArea>
  );
};

export default RulesSidebarNav;
